export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14258.563922a1.jpg";